import { Platform } from 'quasar';

// TODO: write tests
export default ({ Vue }) => {
  Vue.directive('capacitor-select-dialog', {
    bind(el, binding, vnode) {
      if (Platform.is.capacitor) {
        vnode.componentInstance.$on('popup-show', binding.def.onDialogOpen);
        vnode.componentInstance.$on('popup-hide', binding.def.onDialogClose);
      }
    },
    unbind(el, binding, vnode) {
      document.body.classList.add('capacitor-select-dialog--open');
      vnode.componentInstance.$off('popup-show', binding.def.onDialogOpen);
      vnode.componentInstance.$off('popup-hide', binding.def.onDialogClose);
    },
    onDialogClose() {
      document.body.classList.remove('capacitor-select-dialog--open');
    },
    onDialogOpen() {
      document.body.classList.add('capacitor-select-dialog--open');
    },
  });
};
